import { Component, OnInit, AfterViewInit } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageSelectionService } from '../../Services/language-selection.service';
import { GlobalAppService } from '../../Services/global-app.service';
import { APP_LEGACY_MENU_HOST_OLD, environment } from '@env/environment';



@Component({
  selector: 'app-final-logout',
  templateUrl: './final-logout.component.html',
  styleUrls: ['./final-logout.component.scss']
})
export class FinalLogoutComponent implements OnInit, AfterViewInit {
  isGlobalUser: any;
  region: any;
  lang: any;
  closeTabsEnabled: any;
  magento_URL: string ="";

  constructor(
    public _oktaAuth: OktaAuthService,
    private router: Router,
    private translateService: TranslateService,
    private languageServ: LanguageSelectionService,
    private _globalAppService: GlobalAppService) { }

  ngOnInit() {

    // this._globalAppService.getDefaultRegion().subscribe(region => {
    //   if (region) {
    //     this.region = region;
    //     this._globalAppService.getDefaultLanguage().subscribe(lang => {
    //       if (region && lang) {
    //         this.lang = lang;
    //         this.translateService.setDefaultLang(this.region + '/' + this.languageServ.getLanguageCode(this.region, this.lang).toLowerCase());
    //       }
    //     })
    //   }
    // });
    this.closeTabsEnabled = environment.closeTabsEnabled;
    if (window.sessionStorage && sessionStorage.getItem("KCC.region") && sessionStorage.getItem("KCC.language"))
      this.translateService.setDefaultLang(sessionStorage.getItem("KCC.region") + '/' + this.languageServ.getLanguageCode(sessionStorage.getItem("KCC.region"), sessionStorage.getItem("KCC.language")).toLowerCase());
    

      if(sessionStorage.getItem("KCC.region")=="NA"){
        this.magento_URL=environment.magento.url;      
      }
      else if(sessionStorage.getItem("KCC.region")=="EMEA"){
        this.magento_URL=environment.magentoEMEA.url;
      }
      else if(sessionStorage.getItem("KCC.region")=="APAC"){
        this.magento_URL=this.magento_URL;
      }
         
  }

  ngAfterViewInit()
  {
    if (window.sessionStorage) {
      window.sessionStorage.clear();
    }

    if (localStorage) {
      localStorage.removeItem('session-id');
    }

    this.logoutAllSites();
    
  }

  login() {
    this.router.navigateByUrl("/");
  }

  logoutAllSites() {
    window.open(this.magento_URL + '/customerprofile/index/externallogout/','_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=10, height=10, visible=none').close(); 
    window.open(APP_LEGACY_MENU_HOST_OLD + '/UI/Other/Logout.aspx','_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=10, height=10, visible=none').close(); 
  }

}
